export default __webpack_public_path__ + "static/media/greece.20b565a6.webp";